// extracted by mini-css-extract-plugin
export var auto = "_redotech-redo-web-src-spinner-auto";
export var spinner = "_redotech-redo-web-src-spinner-spinner";